import React, { Component } from 'react'
import { Modal, Form, Input, Button } from 'antd'

class channelDirectoryEditModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: '',
      loading: false
    }
  }

  handleOk = (e) => {
    const { id, name, editDirectory, resetTable, form } = this.props

    e.preventDefault()

    this.setState({
      error: '',
      loading: true
    })

    if (id && name) {
      form.validateFields((err, values) => {
        if (!err) {
          editDirectory(id, values.name).then((response) => {
            if (response && !response.data.error) {
              resetTable()
              this.handleCancel()
            } else {
              this.setState({
                error: response.data.error.message
              })
            }

            this.setState({
              loading: false
            })
          })
        } else {
          this.setState({
            loading: false
          })
        }
      })
    }
  }

  handleCancel = (e) => {
    this.setState({
      error: '',
      loading: false
    })
    this.props.closeModal()
  }

  render () {
    const { name, status, form: { getFieldDecorator } } = this.props
    const { loading, error } = this.state

    const layout = {
      labelCol: {
        md: { span: 8 }
      },
      wrapperCol: {
        md: { span: 16 }
      }
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Edit Folder'
        visible={status}
        onCancel={this.handleCancel}
        destroyOnClose
        width={380}
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='indigo' loading={loading} onClick={this.handleOk}>Save</Button>
        ]}
      >
        { error.length > 0 ? <div className='form__error'>{ error }</div> : '' }

        <Form onSubmit={this.handleOk} className='form'>
          <Form.Item {...layout} label='Name'>
            {getFieldDecorator('name', {
              rules: [{ required: true,
                message: 'Please input folder name',
                max: 23,
                pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
              }],
              initialValue: name
            })(
              <Input name='name' maxLength={23} />
            )}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(channelDirectoryEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectoryEditModal/ChannelDirectoryEditModal.jsx